import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import Spinner from "components/spinner/Spinner";
import { displayNotification, sendAPIRequest } from "helpers";
import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MissionContext } from "../contexts/MissionTasksContext";
import { useSelector } from "react-redux";

const initialForm = {
  mission_manager_id: "",
};

const MissionManagerModal = ({ isShow, initModal, data, onSuccess }) => {

  const missionContext = useContext(MissionContext);
  const { t } = useTranslation();
  const [form, setForm] = useState({ ...initialForm, mission_manager_id: missionContext.missionManager });
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const authData = useSelector(s => s.auth.data);
  const handlePopupValueChange = (val) => {
    setForm({ mission_manager_id: val, authUserId: authData.id });
  };
  useEffect(() => {
    if (isShow) {
      setForm({ ...initialForm, mission_manager_id: missionContext.missionManager });
    }
  }, [isShow])

  const handleSave = async () => {
    if (!form.mission_manager_id) {
      displayNotification("error", `${t("-1", "Please Select values")}`);
    }
    else {
      try {
        setIsBtnLoading(true);
        const data = await sendAPIRequest(`/api/pvsa/mission-request/${missionContext?.missionData?.id}`, "PUT", form);
        const response = await data.json();
        if (response.success) {
          setIsBtnLoading(false);
          initModal();
          onSuccess();
          missionContext.taskTrigger();
        } else {
          setIsBtnLoading(false);
        }
      } catch (e) {
        setIsBtnLoading(false);
        console.log(e);
      }
    }

  };

  return (
    <Modal show={isShow} onHide={() => initModal()}>
      <Modal.Header closeButton>
        <Modal.Title>Assign Mission Manager</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AutoCompleteDropdown
          showClearIcon={false}
          error={false}
          required={false}
          multiple={false}
          label={"Select Mission Manager"}
          hasselectall={false}
          options={data}
          onChange={(event, value) => {
            handlePopupValueChange(value.value);
          }}
          value={data.find((r) => r.value == form.mission_manager_id) ?? { value: '', label: '' }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" onClick={handleSave}>
          {isBtnLoading ? (
            <Spinner message="Saving..." />
          ) : (
            <>
              {" "}
              <i className="fa-sharp fa-solid fa-check"></i>
              {t("85", "Save")}
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

MissionManagerModal.defaultProps = {
  isShow: false,
  initModal: () => { },
  data: [],
  handleSave: () => { },
  onSuccess: () => { }

};

export default MissionManagerModal;
